module.exports = __webpack_public_path__ + "img/logo.b404a655.svg";